import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Component({
    selector: 'app-fund',
    templateUrl: './fund.component.html',
    styleUrls: ['./fund.component.scss'],
})
export class FundComponent implements OnInit {

    onboardingGroups = [
        {
            name: 'Investment Amount',
            id: 1,
            title: 'How much do you want to invest?',
            description: 'Enter an amount you are comfortable with',
            complete: true,
        },
        // {
        //     name: 'Fund Distribution',
        //     id: 2,
        //     title: 'How do you want to distrubute your investment',
        //     description:
        //         'Adjust the slider to suit you fund distribution ratio',
        //     complete: false,
        // },
        {
            name: 'Make Payment',
            id: 2,
            title: 'Select a payment method',
            description: 'Select your preferred payment method.',
            complete: false,
        },
    ];

    currentSection = 1;

    isCardComplete = false;
    index: number;

    check() {
        if (this.currentSection == 1) {
            this.checkAmount();
        }
    }

    goToNextSection(index: number) {
        if (!index && index !== 0) {
            if (this.currentSection < 3) {
                this.currentSection += 1;
            }
            return true;
        }

        this.currentSection = index;
    }

    setItemClass(item) {
        const classes = {
            complete: item.complete,
            active: this.currentSection === item.id,
        };
        return classes;
    }

    constructor(private toastr: ToastrService, private router: Router,) {}

    ngOnInit() {
        localStorage.removeItem('advAmount')
    }

    checkAmount() {
        let amount = localStorage.advAmount;
        if (!amount || amount === '' || amount == undefined) {
            this.toastr.info('Amount is empty!', 'Fill all fields!', {
                positionClass: 'toast-top-center',
                timeOut: 3000,
            });
        } else {
            if(amount < 100){
                this.toastr.warning('Amount is too low!', 'You cannot funnd less than $100 !', {
                    positionClass: 'toast-top-center',
                    timeOut: 3000,
                });
            }
            else 
            this.goToNextSection(this.index);
        }
    }
}
